import { URLs } from "../url";
import { getHeader } from "../headers";
import { handleUnauthorized } from "../fetchRequest";

const reportsPostApi = async (body: any) => {
  const newURL = process.env.REACT_APP_HOST_API + URLs.reports;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify({ data: body }),
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const executeReportsPostApi = async (body: any) => {
  const newURL = process.env.REACT_APP_HOST_API + URLs.executeReport;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(body),
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const reportExportExcelApi = async (body: any) => {
  const newURL = `${process.env.REACT_APP_HOST_API}${URLs.reports}/ExportExcel`;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify(body),
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.blob();
    }
    // return await response.json();
    return await response.blob();
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { reportsPostApi, executeReportsPostApi, reportExportExcelApi };
